import { vendorApiNames } from '../names';
import { arubaNewCentralDefaults } from './arubaNewCentral';
import { awsDefaults } from './aws';
import { azureDefaults } from './azure';
import { checkpointDefaults } from './checkpoint';
import { ciscoApicDefaults } from './ciscoApic';
import { ciscoFmcDefaults } from './ciscoFmc';
import { f5osADefaults, f5osCDefaults } from './f5os';
import { forcePointDefaults } from './forcePoint';
import { gcpDefaults } from './gcp';
import { juniperMistDefaults } from './juniperMist';
import { merakiDefaults } from './meraki';
import { nsxTDefaults } from './nsxT';
import { prismaDefaults } from './prisma';
import { ruckusVszDefaults } from './ruckusVsz';
import { silverPeakDefaults } from './silverPeak';
import { veloCloudDefaults } from './veloCloud';
import { versaDefaults } from './versa';
import { viptelaDefaults } from './viptela';

export const defaultVendorApiSettings = {
  [vendorApiNames.arubaNewCentral]: arubaNewCentralDefaults,
  [vendorApiNames.aws]: awsDefaults,
  [vendorApiNames.azure]: azureDefaults,
  [vendorApiNames.checkpoint]: checkpointDefaults,
  [vendorApiNames.ciscoapic]: ciscoApicDefaults,
  [vendorApiNames.ciscofmc]: ciscoFmcDefaults,
  [vendorApiNames.f5osa]: f5osADefaults,
  [vendorApiNames.f5osc]: f5osCDefaults,
  [vendorApiNames.forcepoint]: forcePointDefaults,
  [vendorApiNames.gcp]: gcpDefaults,
  [vendorApiNames.junipermist]: juniperMistDefaults,
  [vendorApiNames.meraki]: merakiDefaults,
  [vendorApiNames.nsxT]: nsxTDefaults,
  [vendorApiNames.prisma]: prismaDefaults,
  [vendorApiNames.ruckusvsz]: ruckusVszDefaults,
  [vendorApiNames.silverpeak]: silverPeakDefaults,
  [vendorApiNames.velocloud]: veloCloudDefaults,
  [vendorApiNames.versa]: versaDefaults,
  [vendorApiNames.viptela]: viptelaDefaults,
};
